import ChartSkeleton from "@/components/pages/charts/ChartSkeleton";

/** Matches `ReusableChart` panel chrome so lazy-loaded home chart does not shift layout. */
export default function ChartPanelFallback(): React.ReactElement {
  return (
    <div className="flex-1 flex flex-col border border-foreground/5 max-sm:border-foreground/10 p-3 max-sm:pr-0 sm:p-[22px] min-h-[543px] min-[1800px]:min-h-[706px] bg-foreground/2 backdrop-blur-xs">
      <div className="flex flex-wrap justify-between items-center gap-3 max-sm:pr-3 mb-4 min-h-[34px]" aria-hidden>
        <div className="h-[26px] w-[min(100%,280px)] rounded-sm bg-white/5" />
        <div className="h-[26px] w-[72px] rounded-sm bg-white/5" />
      </div>
      <div className="w-full flex-1 min-h-0 overflow-hidden">
        <ChartSkeleton hideHeader />
      </div>
    </div>
  );
}
